var React = require('react');

function FourthCircle (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Designs","fillRule":"evenodd","strokeWidth":"1"},React.createElement("g",{"id":"✅-Lyra-Home-","transform":"translate(-764.000000, -316.000000)"},React.createElement("g",{"id":"Hero","transform":"translate(-839.000000, -77.000000)"},React.createElement("path",{"id":"Rectangle-Copy-5","d":"M1703,393 L1721,393 L1721,511 L1603,511 L1603,493 C1603,437.771525 1647.77153,393 1703,393 Z"})))));
}

FourthCircle.defaultProps = {"className":"fill-current stroke-current","version":"1.1","viewBox":"0 0 118 118"};

module.exports = FourthCircle;

FourthCircle.default = FourthCircle;
